module.exports = __webpack_public_path__ + "img/世航动态选中备份.a6f489c5.png";